<template>
  <section>
    <p class="gp-section-title">
      <span>{{ position }}</span
      >Dachnutzung
    </p>

    <div class="g-pb-10" v-if="description">
      <p class="gea-two-column-description">
        {{ description }}
      </p>
    </div>

    <div class="gp-2-column">
      <div class="gp-left-column">
        <option-list :options="options" :title="optionsTitle" module="dachnutzung" @select="optionSelected"></option-list>
      </div>

      <div class="gp-right-column">
        <section-content title="Empfehlung" :body="contentBody"></section-content>
      </div>
    </div>
  </section>
</template>

<script>
import OptionList from "../components/OptionList.vue";
import SectionContent from "../components/SectionContent.vue";
export default {
  components: { SectionContent, OptionList },
  name: "Dachnutzung",

  async created() {
    await this.$store.dispatch("dachnutzung/fetchOptions");
    this.$store.dispatch("dachnutzung/selectOption", this.options[0]);
  },

  computed: {
    contentTitle() {
      let selection = this.$store.state.dachnutzung.selection;
      if (!selection.texts) return "";
      if (!selection.texts.title) return "";

      return selection.texts.title;
    },

    contentBody() {
      let selection = this.$store.state.dachnutzung.selection;
      if (!selection.texts) return "";
      if (!selection.texts.body) return "";

      return selection.texts.body;
    },

    optionsTitle() {
      return "Wie wird das Dach genutzt?";
    },

    options() {
      return this.$store.state.dachnutzung.options;
    },
  },

  methods: {
    optionSelected(option) {
      this.$store.dispatch("dachnutzung/selectOption", option);
    },
  },

  props: ["position", "description"],
};
</script>

<style></style>
